export enum PageTab {
  Conflicts = 'conflicts',
  Policies = 'policies'
}
